import React from 'react';
const GroupFiles: React.FC<{
  groupId?: string;
}> = ({
  groupId
}) => {
  return <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1223">
      <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-1224">File</h2>
      <p className="text-gray-500" data-id="element-1225">Sezione in sviluppo</p>
    </div>;
};
export default GroupFiles;